















import { defineComponent } from '@nuxtjs/composition-api'
import { computed } from '@vue/composition-api'

export default defineComponent({
  name: 'CardAdvantage',
  props: {
    subtitle: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    background: {
      type: String,
      default: '',
    },
    radius: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    withImage: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const styles = computed(() => ({
      '--advantage-card-background': props.background,
      '--advantage-card-radius': props.radius,
    }))

    return {
      styles,
    }
  },
})
